module.exports = __webpack_public_path__ + "img/o6.de7ce758.png";